import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';
import { Nullable } from 'shared_DEPRECATED/types';

export const useChatQuery = ({
  chatId,
  onSuccess,
}: {
  chatId: Nullable<string>;
  onSuccess?: (data: any) => void;
}) => {
  const { request } = useQueryHTTPRequest();

  return useQuery(
    [queryKeys.chats, chatId],
    () => request({ url: `/api/chats/${chatId}` }),
    {
      onSuccess,
      enabled: !!chatId,
    }
  );
};
